module.exports = __webpack_public_path__ + "static/media/sidenav-icon-categories.b949f3c2.svg";